import { memo } from 'react';
import { Activity, Flame, RadioTower, Waves } from 'lucide-react';

import type { BoardNavigationProps } from '@/features/opportunities/opportunityFilterModel';
import type { EnrichedOpportunity } from '@/models/marketData';

export const MarketPulse = memo(
  ({
    opportunities,
    activeBoard,
    onNavigate,
  }: { opportunities: EnrichedOpportunity[] } & BoardNavigationProps) => {
    const stats = [
      {
        label: 'Momentum ready',
        value: opportunities.filter(({ metrics }) => metrics.momentumReady).length,
        hint: 'ADX ≥ 25 · RSI 55–70',
        icon: Activity,
        tone: 'cyan',
      },
      {
        label: 'Volume surge',
        value: opportunities.filter(({ indicators }) => indicators.volumeRatio20 >= 1.5).length,
        hint: 'Volume ratio ≥ 1.5×',
        icon: Waves,
        tone: 'violet',
      },
      {
        label: 'Fresh MACD',
        value: opportunities.filter(({ metrics }) => metrics.freshMacdCrossover).length,
        hint: 'New bullish crossovers',
        icon: RadioTower,
        tone: 'green',
      },
      {
        label: 'Overheated RSI',
        value: opportunities.filter(({ indicators }) => indicators.rsi14 >= 70).length,
        hint: 'RSI ≥ 70 · use caution',
        icon: Flame,
        tone: 'amber',
      },
    ];

    return (
      <div className="pulse-grid" aria-label="Momentum pulse">
        {stats.map(({ label, value, hint, icon: Icon, tone }) => (
          <button
            type="button"
            className={`pulse-card board-filter pulse-card--${tone}`}
            key={label}
            onClick={() => onNavigate(label)}
            aria-pressed={activeBoard === label}
            aria-controls="opportunity-radar"
            aria-label={`View ${label} stocks`}
          >
            <div>
              <span>{label}</span>
              <strong>{value}</strong>
              <small>{hint}</small>
              <span className="board-filter__link">View stocks ?</span>
            </div>
            <Icon size={17} aria-hidden="true" />
          </button>
        ))}
      </div>
    );
  },
);
